var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integration-icon-table-cell"},[(_vm.icon)?_c('div',{staticClass:"integration-icon-table-cell__icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}):(_vm.whiteLabelingConfig.domain)?_c('company-logo',{attrs:{"domain":_vm.whiteLabelingConfig.domain,"view":"no_text"}}):_c('cynergy-app-no-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }